$(function () {
    $('#mainVisual').bxSlider({
        mode: 'fade',
        speed: 1000,
        auto: true,
        controls: false,
        pager: false,
    });

    $('.header__gnb a').on('click', function (e) {
        const target = $(this).attr('href');
        if (!$(target).length) return;

        e.preventDefault();
        const headerH = $('#siteHeader').outerHeight();
        $('html, body').animate({
            scrollTop: $(target).offset().top - headerH
        }, 500);
    });
});
